// Action Types
export const FETCH_POST_STARTED = "FETCH_POST_STARTED";
export const FETCH_POST_ERROR = "FETCH_POST_ERROR";
export const FETCH_POST_SUCCESS = "FETCH_POST_SUCCESS";
export const POST_POST = "POST_POST";
export const PUT_POST = "PUT_POST";

export interface PostMeta{
    verified: boolean
    signature: any
    edit_number: number
}

// Data types
export interface Post {
    id: number,
    title: string,
    description?: string,
    content?: string,
    copyof?: number,
    images?: any[],
    category?: any,
    created_datetime?: string,
    updated_datetime?: string,
    unique_id?: number,
    meta : null | PostMeta
}
//Reducer State Type
export interface PostsState {
    posts: Post[],
    isFetching: boolean,
    error?: any
}
// Action Data Types
///// GERNERAL REQUEST STATUS HANDLER
export interface FetchPostActionStarted {
    type: typeof FETCH_POST_STARTED
}
export interface FetchPostActionError {
    type: typeof FETCH_POST_ERROR
    error: any
}
///// GERNERAL RESPONSES HANDLER
export interface FetchPostActionSuccess {
    type: typeof FETCH_POST_SUCCESS
    id: number,
    post: Post
}
export interface PostPostAction {
    type: typeof POST_POST,
    id: number,
}
export interface PutPostAction {
    type: typeof PUT_POST,
    id: number,
}
///// GERNERAL REQUESTS

export type PostActionTypes = FetchPostActionStarted | FetchPostActionError | FetchPostActionSuccess | PostPostAction | PutPostAction;